export default __webpack_public_path__ + "static/media/img_7.91df0f16.JPG";